<template>
  <v-container fluid class="shift-scedule-component">
    <div class="page-title-row d-sm-flex align-center justify-space-between">
      <h1 class="page-title font-weight-regular">
        График смен
      </h1>
      <v-btn
        :disabled="!canSaveChanges || isReadonly"
        depressed dark color="#ff9100"
        @click="saveChanges"
        large
        width="300px"
        class="button-save d-none d-sm-block"
        :loading="saving"
      >
        <font-awesome-icon icon="check" />
        СОХРАНИТЬ
      </v-btn>
    </div>

    <loader v-if="isLoading"/>
    <div v-else class="shift-section">
      <div v-for="(group, i) in workSpacesDayData" :key="group.workGroupId">
        <work-space-group
          :group-key="i"
          :name="group.groupName"
          :work-spaces="group.workSpaces"
          :readonly="isReadonly"
        />
      </div>
    </div>

    <v-row class="d-sm-none">
      <v-col cols="12">
        <v-btn
          :disabled="!canSaveChanges || isReadonly"
          depressed dark color="#ff9100"
          @click="saveChanges"
          large
          width="300px"
          class="button-save"
          :loading="saving"
        >
          <font-awesome-icon icon="check" />
          СОХРАНИТЬ
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

  import mixinSnackbarMessage from '@/mixins/snackbar-message'
  import Loader from '@/components/loader/Loader'
  import { mapGetters } from 'vuex'
  import moment from 'moment'
  import WorkSpaceGroup from '@/components/administrator/work-shift/staff/WorkSpaceGroup'
  // import { WORK_DAY_START } from '@/util/globals'
  // import { DateTime } from 'luxon'

  export default {
    name: 'DayWorkSchedule',
    mixins: [mixinSnackbarMessage],
    components: {
      WorkSpaceGroup,
      Loader,
    },

    data () {
      return {
        isLoading: false,
        saving: false,
      }
    },

    watch: {
      selectedDate (newValue) {
        this.fetchDayWorkSchedulesScheme(this.selectedDate)
      },
    },

    computed: {
      ...mapGetters({
        selectedDate: 'orders/getSelectedDate',
        selectedFilialId: 'branches/getGlobalFilialId',
        workSpacesDayData: 'dayWorkSchedule/getWorkSpacesDayData',
        canSaveChanges: 'dayWorkSchedule/canSaveChanges',
      }),
      formattedSelectedDate () {
        return moment(this.selectedDate, 'YYYY-MM-DD').format('DD.MM.YYYY')
      },
      isReadonly () {
        return this.saving /* || this.isLastDays */
      },
      isNotToday () {
        return this.selectedDate !== moment().format('YYYY-MM-DD')
      },
      isLastDays () {
        return moment(this.selectedDate, 'YYYY-MM-DD').isBefore(moment.now(), 'day')
      },
    },

    methods: {
      fetchDayWorkSchedulesScheme () {
        this.isLoading = true
        this.$store.dispatch('dayWorkSchedule/fetchWorkSpacesFullData')
          .catch((err) => this.showErrorFromResponse(err))
          .finally(() => {
            this.isLoading = false
          })
      },

      saveChanges () {
        this.saving = true
        this.$store.dispatch('dayWorkSchedule/saveModifiedWorkSchedules')
          .catch((err) => this.showErrorFromResponse(err))
          .finally(() => { this.saving = false })
      },
    },

    created () {
      this.fetchDayWorkSchedulesScheme()
    },

    beforeDestroy () {
      this.$store.commit('dayWorkSchedule/resetWorkSpaces')
    },
  }
</script>

<style lang="less" scoped>
.shift-scedule-component {
  padding-top: 40px;
  ::v-deep {
    .theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
      background-color: @color-btn-grey !important;
      color: #fff !important;
    }

    .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
      box-shadow: none;
      border: 1px solid #ccc;
    }
  }

  .button-save {
    height: 64px;
    font-size: 14px;
    box-shadow: 0 3px 6px #00000029 !important;

    svg {
      margin-right: 15px;
    }
  }

  .page-title {
    font-weight: bold;
  }
  .page-title-row {
    margin-bottom: 35px;
  }

  .shift-section {
    position: relative;
  }
}

</style>
